import React, { useState, useEffect } from 'react';
import axios from 'axios';
import MainChart from './MainChart';
import AutorizacionesDetailModal from './AutorizacionesDetailModal'; // Import the new modal component

// Helper function to format date string from YYYY-MM-DDTHH:mm:ss.sssZ to DD/MM/YYYY
const formatDateToDDMMYYYY = (dateString) => {
  const date = new Date(dateString);
  const day = String(date.getUTCDate()).padStart(2, '0');
  const month = String(date.getUTCMonth() + 1).padStart(2, '0'); // Months are 0-indexed
  const year = date.getUTCFullYear();
  return `${day}/${month}/${year}`;
};

const getAreaLabel = (areaCode, presupuestos) => {
  const areaMap = { a: 'Ambulatorio', i: 'Internaciones', pri: 'Practica en Internado' };
  const baseLabel = areaMap[areaCode] || areaCode;
  if (presupuestos === true || presupuestos === 't' || presupuestos === 'true') {
    return `${baseLabel} (Por Presupuesto)`;
  }
  return baseLabel;
};


const AutorizacionesChart = ({ selectedDelegacion, selectedDate }) => {
  const [rawData, setRawData] = useState([]);
  const [chartData, setChartData] = useState([]);
  const [areaChartData, setAreaChartData] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  const [modalIsOpen, setModalIsOpen] = useState(false);
  const [modalDetailData, setModalDetailData] = useState(null);

  useEffect(() => {
    const fetchAutorizacionesData = async () => {
      try {
        const response = await axios.get('/api/autorizaciones');
        setRawData(response.data);
      } catch (err) {
        console.error('Error fetching autorizaciones data:', err);
        setError('Error al cargar los datos de autorizaciones.');
      } finally {
        setLoading(false);
      }
    };

    fetchAutorizacionesData();
  }, []);

  useEffect(() => {
    let filtered = rawData.map(item => ({
      fecha: item.fecha,
      indicador: item.canal,
      valor: item.valor,
      delegacion: item.delegacion,
      usuario: item.indicador
    }));

    if (selectedDelegacion && selectedDelegacion !== 'Todas') {
      filtered = filtered.filter(item => item.delegacion === selectedDelegacion);
    }

    setChartData(filtered);

    let areaData = rawData.map(item => ({
      fecha: item.fecha,
      indicador: getAreaLabel(item.area, item.presupuestos),
      valor: item.valor,
      canal: item.canal,
      usuario: item.indicador,
      delegacion: item.delegacion,
      area: item.area,
      presupuestos: item.presupuestos
    }));

    if (selectedDelegacion && selectedDelegacion !== 'Todas') {
      areaData = areaData.filter(item => item.delegacion === selectedDelegacion);
    }

    setAreaChartData(areaData);
  }, [rawData, selectedDelegacion, selectedDate]);

  const handleSegmentClick = (clickedDate, clickedChannel) => {
    const usersAndDelegations = rawData.filter(item => 
      formatDateToDDMMYYYY(item.fecha) === clickedDate &&
      item.canal === clickedChannel &&
      (selectedDelegacion === 'Todas' || item.delegacion === selectedDelegacion)
    );
    
    setModalDetailData({ clickedDate, clickedChannel, usersAndDelegations });
    setModalIsOpen(true);
  };

  const handleAreaSegmentClick = (clickedDate, clickedAreaLabel) => {
    const usersAndDelegations = rawData.filter(item => {
      const itemLabel = getAreaLabel(item.area, item.presupuestos);
      return formatDateToDDMMYYYY(item.fecha) === clickedDate && itemLabel === clickedAreaLabel;
    });

    setModalDetailData({ clickedDate, clickedChannel: clickedAreaLabel, usersAndDelegations });
    setModalIsOpen(true);
  };

  const handleCloseModal = () => {
    setModalIsOpen(false);
    setModalDetailData(null);
  };

  if (loading) {
    return <div className="text-center">Cargando datos de autorizaciones...</div>;
  }

  if (error) {
    return <div className="text-center text-danger">{error}</div>;
  }

  return (
    <div className="AutorizacionesChart mt-4">
      <MainChart data={chartData} title='Autorizaciones por Canal y Fecha' onSegmentClick={handleSegmentClick} />
      <div className="mt-3">
        <MainChart data={areaChartData} title='Autorizaciones por Area' onSegmentClick={handleAreaSegmentClick} />
      </div>
      <AutorizacionesDetailModal 
        isOpen={modalIsOpen}
        onClose={handleCloseModal}
        detailData={modalDetailData}
        selectedDelegacionFilter={selectedDelegacion}
      />
    </div>
  );
};

export default AutorizacionesChart;
